import { IconHeart, IconCarrier, IconDermatology, IconCytogenetics, IconExome, IconBlood, IconCancer, IconImmunology, IconMetabolic, IconBrain, IconNips, IconEye, IconPediatrics, IconMedicine, IconPregnancyLoss, IconPregnancy, IconApple, IconStethoscope, IconSomatic } from '@invitae/iconograph-react';
export { CircleVariant, ColorVariant, SizeVariant } from '@invitae/iconograph-react';

/* eslint-disable spellcheck/spell-checker */
var iconReference = {
    headerCommercialAreaCardiology: IconHeart,
    headerCommercialAreaCarrier: IconCarrier,
    headerCommercialAreaDermatology: IconDermatology,
    headerCommercialAreaDevelopmentalDisordersCytogenetics: IconCytogenetics,
    headerCommercialAreaExome: IconExome,
    headerCommercialAreaHematology: IconBlood,
    headerCommercialAreaHereditaryCancer: IconCancer,
    headerCommercialAreaImmunology: IconImmunology,
    headerCommercialAreaMetabolicDisordersandNewbornScreening: IconMetabolic,
    headerCommercialAreaNeurology: IconBrain,
    headerCommercialAreaNoninvasivePrenatalScreeningNIPS: IconNips,
    headerCommercialAreaOphthalmology: IconEye,
    headerCommercialAreaPediatricGenetics: IconPediatrics,
    headerCommercialAreaPharmacogenomics: IconMedicine,
    headerCommercialAreaPregnancyLossandInfertility: IconPregnancyLoss,
    headerCommercialAreaPrenatalDiagnosis: IconPregnancy,
    headerCommercialAreaPreventive: IconApple,
    headerProductTypeCarrier: IconCarrier,
    headerProductTypeDevelopmentalDisordersCyto: IconCytogenetics,
    headerProductTypeDevelopmentalDisordersCytoParentalFollowUp: IconCytogenetics,
    headerProductTypeDiagnostic: IconStethoscope,
    headerProductTypeDiagnosticRna: IconStethoscope,
    headerProductTypeExome: IconExome,
    headerProductTypeExomePreventiveAddon: IconExome,
    headerProductTypeExomeSlice: IconExome,
    headerProductTypeExomeV2: IconExome,
    headerProductTypeExomeV3: IconExome,
    headerProductTypeFragileXDiagnostic: IconStethoscope,
    headerProductTypeIHC: IconSomatic,
    headerProductTypeMRDBaseline: IconSomatic,
    headerProductTypeMRDMonitoring: IconSomatic,
    headerProductTypeNIPS: IconNips,
    headerProductTypePGx: IconMedicine,
    headerProductTypePregnancyLossCyto: IconPregnancyLoss,
    headerProductTypePregnancyLossCytogeneticsParentalFollowUp: IconPregnancyLoss,
    headerProductTypePrenatalDiagnosisCytogenetics: IconPregnancy,
    headerProductTypePrenatalDiagnosisCytogeneticsParentalFollowUp: IconPregnancy,
    headerProductTypeProactive: IconApple,
    headerProductTypeRecurrentPregnancyLossOrInfertilityCyto: IconPregnancyLoss,
    headerProductTypeTumorFusionProfile: IconSomatic,
};
/* eslint-enable spellcheck/spell-checker */

export { iconReference };
//# sourceMappingURL=iconReference.esm.js.map
